<style>

</style>

<template>

  <div class="wrapper wrapper-content">
    <div class="container-fluid">
  
    <div class="row">
      <!-- step1 -->
      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 col-md-offset-4 col-sm-offset-3">
        <div ref="step1" class="reg-box" v-if="step1_show">
          <div class="regbox-body widget-body">

            <div class="bg-gray1 text-center">
              <img :src="app_site_logo" style="max-height: 55px; margin-top: 20px; margin-bottom:20px;">
            </div>

            <h5 class="text-primary text-white"><span class="badge badge-pill badge-primary font-weight-light">STEP 1</span> กรุณากรอกข้อมูลให้ถูกต้อง</h5>
            <div class="widget-main">

              <form @submit.prevent="verifyPhoneNumber" class="form-login form-horizontal">
                <div class="form-group">
                  <label class="col-lg-3 col-sm-12 control-label">ชื่อเข้าสู่ระบบ</label>
                  <div class="col-lg-8 col-sm-12">
                    <input type="text" name="forgot_username" class="form-control" placeholder="ชื่อผู้ใช้งานที่ได้ลงทะเบียนไว้" v-model="forgot_username">
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-lg-3 col-sm-12 control-label">ระบุเบอร์โทร</label>
                  <div class="col-lg-8 col-sm-12">
                    <input type="text" name="forgot_mobile_phone" maxlength="10" @keyup="stopPhoneInput" class="form-control" @keypress="onlyNumber" placeholder="เบอร์โทรศัพท์ที่ได้ลงทะเบียนไว้" v-model="forgot_mobile_phone">
                  </div>
                </div>
                <hr>

                <div class="form-group" v-if="GG_CAPTCHA_ENABLE">
                  <label class="col-lg-3 col-sm-12 control-label">คลิกเพื่อยืนยันบุคคล</label>
                  <div class="col-lg-8 col-sm-12">
                    <vue-recaptcha
                      class='gg-captcha'
                      ref="recaptcha"
                      @verify="onVerify"
                      @expired="onExpired"
                      :sitekey="sitekey">
                    </vue-recaptcha>
                  </div>
                </div>
                <hr  v-if="GG_CAPTCHA_ENABLE">
                <div class="form-group">
                  <div class="col-lg-offset-3 col-lg-8">
                    <button class="btn btn-block btn-lotto-primary mb-2" type="submit" :disabled="verify_phone_disabled">
                      <span><i class="fa fa-fw fa-arrow-circle-right"></i> ถัดไป</span>
                    </button>
                  </div>
                </div>
              </form>

            </div>
            <div class="contact-footer">
              <h5 class="text-primary">
                <a :href="line_contact" target="_blank"><span class="badge badge-pill badge-primary font-weight-light"><i class="fa fa-phone"></i></span> ติดต่อเรา</a>
              </h5>
            </div>
          </div>

        </div> <!-- end reg-box -->
      </div>


      <!-- step2 -->
      <div class="col-xs-12 col-sm-8 col-md-8 col-lg-4 col-md-offset-2 col-sm-offset-2 col-lg-offset-4">
        <div ref="step2" class="reg-box" v-if="step2_show">

          <div class="regbox-body widget-body">

            <div class="bg-gray1 text-center">
              <img :src="app_site_logo" style="max-height: 55px; margin-top: 20px; margin-bottom:20px;">
            </div>

            <h5 class="text-primary text-white"><span class="badge badge-pill badge-primary font-weight-light">STEP 2</span> กรอกรหัสผ่านใหม่</h5>

            
            <div class="widget-main">

              <form v-on:submit.prevent class="form-login form-horizontal">
                    
                      <div class="form-group has-feedback">
                        <label for="" class="col-lg-4 col-md-2 col-sm-12 control-label">รหัสผ่าน : </label> 
                        <div
                            class="col-lg-8 col-md-10 col-sm-12"
                            v-bind:class="{ 'form-group--error': $v.credentials.password.$error, 'form-group--success': !$v.credentials.password.$invalid && $v.credentials.password.$dirty }" >
                            <input
                                type="password"
                                class="form-control"
                                name="signup-form-password"
                                aria-describedby="Password"
                                v-model.trim="credentials.password"
                                @input="$v.credentials.password.$touch()"
                                placeholder="password"
                            >
                            <div class="form-group__message" v-if="!$v.credentials.password.$minLength && $v.credentials.password.$error">Passwords must be at least 8 characters.</div>
                            <div class="form-group__message" v-if="$v.credentials.password.$error">Please enter a valid password.</div>
                        </div>
                      </div> 
                      
                      <div class="form-group has-feedback">
                        <label for="confirm_password" class="col-lg-4 col-md-2 col-sm-12 control-label">ยืนยันรหัสผ่าน : </label> 
                        <div
                            class="col-lg-8 col-md-10 col-sm-12"
                            v-bind:class="{ 'form-group--error': $v.credentials.passwordConfirm.$error, 'form-group--success': !$v.credentials.passwordConfirm.$invalid && $v.credentials.passwordConfirm.$dirty }" >
                            <input
                                type="password"
                                class="form-control"
                                name="signup-form-passwordConfirm"
                                aria-describedby="Confirm Password"
                                v-model.trim="credentials.passwordConfirm"
                                @input="$v.credentials.passwordConfirm.$touch()"
                                placeholder="confirm password"
                            >
                            <div class="form-group__message" v-if="$v.credentials.passwordConfirm.$error">Password doesn't match.</div>
                        </div>
                      </div>
                <hr>

                <div class="form-group has-feedback">
                  <div class="col-sm-12">
                    <div class="col-sm-6">
                      <button type="button" class="btn btn-lotto-cancel btn-block mb-2" @click="cancelStep2()"> ยกเลิก</button>
                    </div>
                    <div class="col-sm-6">
                      <button class="btn btn-block btn-lotto-primary mb-2" @click="submit()">
                        <span v-if="pending"><i class="fa fa-circle-o-notch fa-spin fa-fw"></i></span>
                        <span v-else><i class="fa fa-fw fa-arrow-circle-right"></i> ถัดไป</span>
                      </button>
                    </div>
                  </div>
                </div> 

              </form>

            </div>
            <div class="contact-footer">
              <h5 class="text-primary">
                <a :href="line_contact" target="_blank"><span class="badge badge-pill badge-primary font-weight-light"><i class="fa fa-phone"></i></span> ติดต่อเรา</a>
              </h5>
            </div>
          </div>

        </div> <!-- end reg-box -->
      </div>


      <!-- step3 -->
      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-sm-offset-3 col-md-offset-3 col-lg-offset-4">
        <!-- <div ref="step3" class="reg-box"> -->
        <div ref="step3" class="reg-box" v-if="step3_show">

          <div class="regbox-body widget-body">

            <div class="bg-gray1 text-center">
              <img :src="app_site_logo" style="max-height: 55px; margin-top: 20px; margin-bottom:20px;">
            </div>

            <h5 class="text-primary text-white"><span class="badge badge-pill badge-primary font-weight-light">STEP 3</span> รีเซ็ทรหัสผ่านสำเร็จ</h5>
            <div class="widget-main">

              <div class="form-group">
                <div class="col-sm-12 control-label text-center" style="font-size: 44pt; color: green; background-color: white;"><i class="icofont-check-circled"></i></div>
                <div class="col-sm-12 control-label text-center" style="font-size: 14pt; color: green; margin-bottom:10px; background-color: white;">รีเซ็ทรหัสผ่านเรียบร้อย</div>

              </div>

              <div class="form-group">
                <div class="col-sm-12 control-label text-center">กรุณาเข้าสู่เหน้าหลัก เพื่อทำการ login</div>
              </div>

              <div class="form-group has-feedback">
                  <button type="button" class="btn btn-lotto-primary btn-block mb-2" @click="loginPage()"> เข้าสู่หน้าหลัก</button>
              </div>

            </div>
          </div>

        </div> <!-- end reg-box -->
      </div>


    </div>

<a href="#number-sets-modal" ref="openVerify" data-backdrop="static" data-keyboard="false" data-toggle="modal" class="btn btn-primary btn-block hide"></a>


<div id="number-sets-modal"  role="dialog" aria-hidden="true" class="modal inmodal fade">
  <div class="modal-dialog">
    <div class="modal-content animated fadeIn">
      <div class="widget-modal-body">
      <div class="text-center">
        <img :src="app_site_logo" style="max-height: 55px; margin-top: 20px; margin-bottom:20px;">
      </div>
      
      <div class="modal-header">
        <button type="button" ref="closeVerify" data-dismiss="modal" class="close">
          <span aria-hidden="true">×</span>
          <span class="sr-only">Close</span>
        </button> 
        <h6 class="modal-title">โปรดระบุรหัส OTP ที่ได้รับ</h6>
      </div>

      <div class="modal-body">
        <div>

          <div>

            <form class="form-login form-horizontal">
              <div id="nbs-1" class="tab-pane tab-numbersets active">
                <div class="panel-body">

                  <div class="p-sm text-center">
                    <input type="text" name="verify_code" @keyup="stopCodeInput" class="form-control" maxlength="4" @keypress="onlyNumber" placeholder="กรุณาใส่เลข OTP" v-model="verify_code">
                  </div>

                  <div class="text-center">
                    <hr class="m-b-xs">
                  </div>

                  <div class="p-sm text-center">
                    <div class="row">
                      <div class="col-xs-6">
                        <button type="button" class="btn btn-lotto-renew btn-block btn-lg" @click="cancelVerify"> ยกเลิก </button>
                      </div> 
                      <div class="col-xs-6">
                        <button type="button" class="btn btn-lotto-primary btn-block btn-lg" @click="verifyCode" :disabled="verify_code_disabled"> ยืนยัน</button>
                      </div>
                    </div>
                  </div> 

                </div>
              </div> 
            </form>

          </div>
        </div>

    </div>
  </div>
  </div>
  </div><!-- /#modal dialog -->
</div><!-- /#modal -->



    </div>
  </div><!-- /#page-wrapper -->

</template>






<script>
import { required, minLength, sameAs } from 'vuelidate/lib/validators'
import VueRecaptcha from 'vue-recaptcha'


export default {
    components: { VueRecaptcha },
    name: 'newregister',
    data () {
        return {
            reset_token: '',
            forgot_username: '',
            forgot_mobile_phone: '',
            request_id: '',
            verify_code: '',
            verify_code_disabled: true,
            verify_phone_disabled: true,
            success_username: '',

            step1_show: true,
            step2_show: false,
            step3_show: false,

            thai_country_code: '66',
            // sitekey: '6LeiNK4UAAAAAOx6FS3psemI3kfco8uJxOF8CoYP',
            sitekey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI', // TEST SITE KEY

            GG_CAPTCHA_ENABLE: false,
            recaptchaVerified: false,
            pleaseTickRecaptchaMessage: '',
            recaptcha_response: '',

            line_contact: '',

            credentials: {
                password: '',
                passwordConfirm: '',
                // bank_accountConfirm: '',
            },
            pending: false
        }
    },
    methods: {
        onSubmit: function () {
            this.$refs.invisibleRecaptcha.execute()
        },
        onVerify: function (response) {
            this.pleaseTickRecaptchaMessage = ''
            this.recaptchaVerified = true

            this.recaptcha_response = response
            //console.log('Verify: ' + response)
        },
        onExpired: function () {
            console.log('Expired')
        },
        resetRecaptcha () {
            this.$refs.recaptcha.reset() // Direct call reset method
        },
        stopPhoneInput(){
            if (this.forgot_mobile_phone.length == 10) { 
                this.verify_phone_disabled = false
            }
            else { 
                this.verify_phone_disabled = true
            }
        },

        async verifyPhoneNumber() {

            if ( this.GG_CAPTCHA_ENABLE && !this.recaptchaVerified) {
                this.pleaseTickRecaptchaMessage = 'กรุณาคลิกที่ checkbox เพื่อยืนยันว่าท่านไม่ใช่โปรแกรมอัตโนมัติ.'
                this.$toasted.error(this.pleaseTickRecaptchaMessage)

                return true // prevent form from submitting
            }

            if ( !this.forgot_username ) {
                let warning_msg = 'กรุณาระบุชื่อผู้ใช้งาน'
                this.$toasted.error(warning_msg)

                return true // prevent form from submitting
            }

            if ( this.forgot_mobile_phone && this.phonenumber(this.forgot_mobile_phone) ) {

                let request_data = {
                    username: this.forgot_username,
                    mobile_phone: this.forgot_mobile_phone,
                    recaptcha_response: this.recaptcha_response,
                }
                try {
                    let response = await this.$store.dispatch('user/checkForgotUser', request_data)
                    //console.log('verifyPhoneNumber', response)

                    this.reset_token = response.token

                    if ( response.status && response.token ) {

                        // remove prefix zero
                        let phonenum = this.forgot_mobile_phone.substring(1)
                        // add country code
                        phonenum = "" + this.thai_country_code + phonenum

                        let response = await this.$store.dispatch('user/requestPIN', phonenum)
                        //console.log('requestPIN', response)

                        if ( response.request_id ) {
                            this.request_id = response.request_id
                            this.$refs.openVerify.click()
                        }
                        else {
                            this.$toasted.error('Cannot request OTP, try again later. ' + response.error_text)
                        }

                        //skip call API for testing
                        // console.log('phonenum', phonenum)
                        // this.$refs.openVerify.click()

                    }
                    else {
                        this.$toasted.error('ไม่สามารถทำรายการได้ ผู้ใช้งาน หรือ เบอร์โทรศัพท์ ไม่ถูกต้อง')
                    }

                } catch (error) {
                    console.log('error', error )
                    let error_msg = 'There was an error connecting to the server.'
                    // if ( error.response.data ) {
                    //     error_msg = error.response.data.requestError.serviceException.text
                    // }
                    this.$toasted.error(error_msg)

                    let error_obj = {}
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        error_obj = error.response.data
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        error_obj = error.request
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        error_obj = error.message
                    }
                    console.log('error_obj', error_obj)
                }

            }
            else {
                this.$toasted.error('เบอร์โทรศัพท์ไม่ถูกต้อง โปรดกรอกหมายเลขโทรศัพท์ 10 หลัก ด้วยรูปแบบดังนี้ 08XXXXXXXX ')
            }

        },

        phonenumber (phone) {
            let rgx = /^\d{10}$/g
            return phone.match(rgx)
        },

        onlyNumber ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                $event.preventDefault()
            }
        },

        stopCodeInput(){
            //console.log('stopCodeInput', this.verify_code)
            if (this.verify_code.length == 4) { 
                this.verify_code_disabled = false
            }
            else { 
                this.verify_code_disabled = true
            }
            //console.log('stopCodeInput', this.verify_code_disabled)
        },

        async verifyCode() {

            if ( this.verify_code.length > 0 && this.otpcode(this.verify_code) ) {

                //console.log('verifyCode', this.forgot_mobile_phone, this.verify_code)

                let verify_data = {
                    request_id: this.request_id,
                    pin: this.verify_code
                }

                try {

                    let response = await this.$store.dispatch('user/verifyCode', verify_data)
                    if ( response.error_text ) {
                        this.$toasted.error('รหัส OTP ไม่ถูกต้อง. ' + response.error_text)
                    }
                    else {
                        // this.$refs.step1.style["display"] = "none"
                        // this.$refs.step2.style["display"] = "block"
                        this.step1_show = false
                        this.step2_show = true

                        this.$refs.closeVerify.click()
                    }

                    //skip call API for testing
                    // this.step1_show = false
                    // this.step2_show = true
                    // console.log('verify_data', verify_data)
                    // this.$refs.closeVerify.click()


                } catch (error) {
                    let error_msg = 'There was an error connecting to the server.'
                    let error_response = error.response.data
                    if ( error_response ) {
                        error_msg = error_response.requestError.serviceException.text
                    }
                    this.$toasted.error(error_msg)
                }
                this.verify_code = ''

            }
            else {
                this.$toasted.error('หมายเลข OTP ไม่ถูกต้อง โปรดกรอกตัวเลข 4 หลักจาก SMS')
            }

        },

        otpcode (code) {
            let rgx = /^\d{4}$/g
            return code.match(rgx)
        },

        async cancelVerify() {
            //console.log('renewRequest', this.forgot_mobile_phone, this.request_id)

            try {
                let response = await this.$store.dispatch('user/cancelVerify', this.request_id)

                if ( response.error_text ) {
                    if ( response.status == 19 ) {
                        this.$toasted.error('ไม่สามารถยกเลิกได้ภายใน 30 วินาทีแรก กรุณารอสักครู่')
                    }
                    else {
                        this.$toasted.error('Cannot cancel verification. ' + response.error_text)
                    }
                    
                }
                else {
                    this.$toasted.success('ยกเลิกเรียบร้อยแล้ว.')
                    this.$refs.closeVerify.click()
                    this.$router.push({name: 'login'})
                }

            } catch (error) {
                let error_msg = 'There was an error connecting to the server.'
                let error_response = error.response.data
                if ( error_response ) {
                    error_msg = error_response.requestError.serviceException.text
                }
                this.$toasted.error(error_msg)
            }
        },

        cancelStep2(){
            //console.log('cancelStep2', this.verify_code)
            var r = confirm('คุณต้องการยกเลิกการแก้ไขรหัสผ่าน?')
            if (r == true) {
                this.$router.push({name: 'login'})
            }
        },

        async submit () {
            // console.log('submit', this.$v.$invalid)
            // console.log('submit V', this.$v)
            if (this.$v.$invalid) { this.$v.$touch(); return }

            this.pending = true

            const { password, passwordConfirm } = this.credentials

            const credentials = {
                new_password: password,
                confirm_new_password: passwordConfirm,
                token: this.reset_token,
            }
            //console.log('credentials', credentials)

            try {
                await this.$store.dispatch('user/userResetPassword', credentials)
                this.$toasted.success('Successfully reset password')
                //this.$toasted.success('Please wait a moment for the account to activate before you can login.')

                this.success_username = this.credentials.username

                this.credentials.password = ''
                this.credentials.passwordConfirm = ''

                this.$v.$reset()
                // this.$router.push({name: 'login'})

                this.step1_show = false
                this.step2_show = false
                this.step3_show = true

            } catch (error) {

                let error_msg = 'Hmm, something you entered doesn\'t seem right.'
                let response = error.response.data
                if ( response ) {
                    error_msg = response.message
                }
                this.$toasted.error(error_msg)
                this.step1_show = true
                this.step2_show = false
                this.$router.push({name: 'forgot'})

            } finally {
                this.pending = false
            }
        },

        async loadLineContact () {
            try {
                const response = await this.$store.dispatch('information/getLineContact')
                this.line_contact = response.link
            } catch (error) {
                console.log('error', error)
            }
        },

        loginPage () {
            this.$router.push({name: 'login',})
        },

    },
    validations: {

        credentials: {
            password: {
                required,
                minLength: minLength(8)
            },
            passwordConfirm: {
                sameAs: sameAs('password')
            }
        }
    },
    created () {
        let logo = (process.env.VUE_APP_SITE).toLowerCase() + '_logo.png'
        try {
            this.app_site_logo = require('@/assets/images/'+ logo)
        } catch (error) {
            this.app_site_logo = require('@/assets/images/'+ 'dummy_logo.png')
        }

        if ( process.env.VUE_APP_RECAPTCHA_ENABLE ) {
            this.GG_CAPTCHA_ENABLE = true
            this.sitekey = process.env.VUE_APP_RECAPTCHA_SITEKEY
        }

        this.loadLineContact()

    },
    destroyed () {
    }
}
</script>

<style lang="scss" scoped>
  .gg-captcha {
    @media screen and (max-width: 320px) {
      transform:scale(0.77);
      -webkit-transform:scale(0.77);
      transform-origin:0 0;
      -webkit-transform-origin:0 0;
    }
    @media screen and (min-width: 321px) and (max-width: 375px) {
      transform:scale(0.92);
      -webkit-transform:scale(0.92);
      transform-origin:0 0;
      -webkit-transform-origin:0 0;
    }
    
    @media screen and (min-width: 1024px) and (max-width: 1400px) {
      transform:scale(0.8);
      -webkit-transform:scale(0.8);
      transform-origin:0 0;
      -webkit-transform-origin:0 0;
    }

  }

  .btn-lotto-primary {
      // color: #fff;
      // background-color: #4c8ae7;
      // color: #212529;
      // background-color: #ffc107;
      color: #0f5413;
      background-color: #FFEB3B;
      &:hover {
        color: #fff;
      }
      font-size: 14pt;
      border-radius: 10px;
  }

  .btn-lotto-renew {
      color: #fff;
      background-color: lightgrey;
      font-size: 14pt;
      border-radius: 10px;
  }

  .btn-lotto-cancel {
      color: #fff;
      background-color: dimgray;
      font-size: 14pt;
      border-radius: 10px;
  }

  .regbox-header {
      position: relative;
      min-height: 38px;
      // background: lightgrey;
      padding-left: 12px;
  }


  .regbox-footer {
    position: relative;
    min-height: 38px;
    // background: lightgrey;
    padding-left: 12px;
  }

  .widget-body {
    // background: rgba(4, 140, 252, 0.4) !important;
    // border: 2px solid #4c8ae7;
    // border-radius: 10px;
    // background-color: hsl(195, 79%, 42%) !important;
    // background-repeat: repeat-x;
    // filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#2db8e6", endColorstr="#1695bf");
    // background-image: -khtml-gradient(linear, left top, left bottom, from(#2db8e6), to(#1695bf));
    // background-image: -moz-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: -ms-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #2db8e6), color-stop(100%, #1695bf));
    // background-image: -webkit-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: -o-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: linear-gradient(#2db8e6, #1695bf);
    // border: 2px solid #4c8ae7;

    background-image: linear-gradient(#2E7D32, #0f5413) !important;
    border: 2px solid white;
    border-radius: 10px;
  }

  .regbox-body {
    
    // background: rgba(4, 140, 252, 0.4) !important;
    // font-family:tahoma;
    // color: black !important;
    // border-radius: 10px;
    // background-color: hsl(195, 79%, 42%) !important;
    // background-repeat: repeat-x;
    // filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#2db8e6", endColorstr="#1695bf");
    // background-image: -khtml-gradient(linear, left top, left bottom, from(#2db8e6), to(#1695bf));
    // background-image: -moz-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: -ms-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0%, #2db8e6), color-stop(100%, #1695bf));
    // background-image: -webkit-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: -o-linear-gradient(top, #2db8e6, #1695bf);
    // background-image: linear-gradient(#2db8e6, #1695bf);
    // border: 2px solid #4c8ae7;

    background-image: linear-gradient(#2E7D32, #0f5413) !important;
    border: 2px solid white;
    border-radius: 10px;

    padding: 5px;
  }

  .reg-box {
    margin: 10px auto;
  }
  
  .modal-header {
    background: #2E7D32;
  }

  .modal-body {
    background: #2E7D32;
    height: 60%; 
  }

  .modal { 
      position: fixed; 
      top: 3%; 
      right: 3%; 
      left: 3%; 
      width: auto; 
      margin: 10;
      padding: 3px; 
      border-radius: 10px;
  }

  .widget-modal-body {
    background: #1D3B1A;
    color: black;
    border: 0px solid black; 
  }

  .g-recaptcha {
    transform: scale(2);
    transform-origin: 0 0;
  }

  .widget-container {
    background: #2E7D32;
    color: #fff;
  }

  .control-label {
    color: #fff;
  }
  label.control-label {
    text-align: left;
  }

  .contact-footer {
    // background-color: #4c8ae7;
    background-color: #1D3B1A;
    margin-left: -5px;
    margin-right: -5px;
    margin-bottom: -5px;
    padding: 10px;

    a {
      color: #fff;
    }
  }

</style>
